import { HubFeature } from "@ats/api/cm";
import { LocDefs, MapLocKeys } from "@cm/core/localization";
import { candidateSecurityDPRoot } from "../../candidate-security-meta";

const dpRoot = `${candidateSecurityDPRoot}|Exam Photos|Signatures`;

export type PhotosSignaturesLoc = | 'SPPhotosSignaturesRegLabel';

export const photosSignaturesLocs: LocDefs<PhotosSignaturesLoc> = {
    SPPhotosSignaturesRegLabel: {
        defaultValue: 'Registration',
        description: 'Text for the registration label.',
        displayPath: `${dpRoot}|Registration`,
        displayType: 'Label',
        portal: 'SP',
        feature: HubFeature.Exam,
    }
};

export const LOC_KEYS = MapLocKeys<PhotosSignaturesLoc>(photosSignaturesLocs);
